import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { INCLUDE_EXCLUDE_OPTIONS } from '../../fieldsConfig';

const IncludeExcludeMultiselectValue = ({ rule, onValueChange, disabled }) => (
  <div className='include-exclude-multiselect'>
    <Dropdown
      selection
      options={INCLUDE_EXCLUDE_OPTIONS}
      value={rule.includeExclude}
      onChange={(e, data) => onValueChange(rule.instanceId, 'includeExclude', data.value)}
      disabled={disabled}
    />
    <Dropdown
      multiple
      selection
      options={rule.valueOptions}
      value={rule.selectedValues}
      onChange={(e, data) => onValueChange(rule.instanceId, 'selectedValues', data.value)}
      placeholder='Select options...'
      disabled={disabled}
    />
  </div>
);

IncludeExcludeMultiselectValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default IncludeExcludeMultiselectValue;
